/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName } from './ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName';
import {
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameFromJSON,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameFromJSONTyped,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameToJSON,
} from './ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName';

/**
 * 
 * @export
 * @interface ExecRiskRelationshipSchedule
 */
export interface ExecRiskRelationshipSchedule {
    /**
     * 
     * @type {ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName}
     * @memberof ExecRiskRelationshipSchedule
     */
    NameOfOrganization?: ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskRelationshipSchedule
     */
    OrganizationTypeDesc?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskRelationshipSchedule
     */
    DescriptionOfRelationship?: string;
}

/**
 * Check if a given object implements the ExecRiskRelationshipSchedule interface.
 */
export function instanceOfExecRiskRelationshipSchedule(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskRelationshipScheduleFromJSON(json: any): ExecRiskRelationshipSchedule {
    return ExecRiskRelationshipScheduleFromJSONTyped(json, false);
}

export function ExecRiskRelationshipScheduleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskRelationshipSchedule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'NameOfOrganization': !exists(json, 'NameOfOrganization') ? undefined : ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameFromJSON(json['NameOfOrganization']),
        'OrganizationTypeDesc': !exists(json, 'OrganizationTypeDesc') ? undefined : json['OrganizationTypeDesc'],
        'DescriptionOfRelationship': !exists(json, 'DescriptionOfRelationship') ? undefined : json['DescriptionOfRelationship'],
    };
}

export function ExecRiskRelationshipScheduleToJSON(value?: ExecRiskRelationshipSchedule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'NameOfOrganization': ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameToJSON(value.NameOfOrganization),
        'OrganizationTypeDesc': value.OrganizationTypeDesc,
        'DescriptionOfRelationship': value.DescriptionOfRelationship,
    };
}

